import { render, staticRenderFns } from "./workFlowRoleManagement.vue?vue&type=template&id=f4eca4f8&"
import script from "./workFlowRoleManagement.vue?vue&type=script&lang=js&"
export * from "./workFlowRoleManagement.vue?vue&type=script&lang=js&"
import style0 from "./workFlowRoleManagement.vue?vue&type=style&index=0&id=f4eca4f8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports